import { render, staticRenderFns } from "./Consultantview.vue?vue&type=template&id=b725ad40&"
import script from "./Consultantview.vue?vue&type=script&lang=js&"
export * from "./Consultantview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports